import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $deleteTableRowAtSelection } from "@lexical/table";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import { useCallback } from "react";
import { ToolbarIconButton } from "../../toolbar/toolbar-icon-button";

import type { FC } from "react";

export const DeleteRowButton: FC<{ onClick: () => void }> = ({ onClick }) => {
  const [editor] = useLexicalComposerContext();

  const handleDeleteRow = useCallback(() => {
    editor.update(() => {
      $deleteTableRowAtSelection();
      onClick();
      return;
    });
  }, [editor, onClick]);

  return (
    <ToolbarIconButton
      data-analytics-id="lexical-table-menu-delete-row"
      disabled={!editor._editable}
      label="Delete row"
      icon={<DeleteOutline color="error" data-testid="DeleteIcon" fontSize="small" />}
      data-testid="table-menu-delete-row"
      aria-label="delete-row"
      onClick={handleDeleteRow}
    />
  );
};
